import { useState } from "react";

function EMICalculator() {
  const [amount, setAmount] = useState("");
  const [rate, setRate] = useState("");
  const [years, setYears] = useState("");
  const [emi, setEmi] = useState(null);

  const calculateEMI = () => {
    const P = Number(amount);
    const annualRate = Number(rate);
    const N = Number(years) * 12;

    if (!P || !annualRate || !N) {
      alert("Fill all fields");
      return;
    }

    const R = annualRate / 12 / 100;

    const emiValue =
      (P * R * Math.pow(1 + R, N)) /
      (Math.pow(1 + R, N) - 1);

    setEmi(emiValue.toFixed(0));
  };

  return (
    <div className="emi-section">
      <h1>💰 EMI Calculator</h1>

      <div className="emi-box">
        <input
          type="number"
          placeholder="Loan Amount (₹)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        <input
          type="number"
          placeholder="Interest Rate (%)"
          value={rate}
          onChange={(e) => setRate(e.target.value)}
        />

        <input
          type="number"
          placeholder="Time (Years)"
          value={years}
          onChange={(e) => setYears(e.target.value)}
        />

        <button onClick={calculateEMI}>
          Calculate EMI
        </button>

        {emi && (
          <h2 className="emi-result">
            Monthly EMI: ₹{emi}
          </h2>
        )}
      </div>
    </div>
  );
}

export default EMICalculator;